@if (!auth && !isLoading) {
  <div id="main">
    <!-- Card Number  -->
    <form>
      <div class="row">
        <div class="div col-md-12 no-padding">
          <span class="has-float-label">
            <input
              type="text"
              id="card-number"
              class="form-control input-field"
              title="card number"
              aria-label="enter your card number"
              value=""
              tabindex="1"
              placeholder=""
              required
              />
              <label class="form-label" for="card-number"
                >Card number <span class="asterisk">*</span></label
                >
              </span>
            </div>
          </div>
          <!-- Expiry Month -->
          <div class="row">
            <div class="col-md-6 no-padding">
              <span class="has-float-label">
                <select
                  id="expiry-month"
                  class="form-control input-md"
                  required=""
                  readonly
                  >
                  <option value=""></option>
                  <option value="01">January</option>
                  <option value="02">February</option>
                  <option value="03">March</option>
                  <option value="04">April</option>
                  <option value="05">May</option>
                  <option value="06">June</option>
                  <option value="07">July</option>
                  <option value="08">August</option>
                  <option value="09">September</option>
                  <option value="10">October</option>
                  <option value="11">November</option>
                  <option value="12">December</option>
                </select>
                <label class="form-label" for="expiry-month"
                  >Expiry month (mm) <span class="asterisk">*</span></label
                  >
                </span>
              </div>
              <div class="col-md-6 no-padding">
                <span class="has-float-label">
                  <select
                    id="expiry-year"
                    class="form-control input-md"
                    required=""
                    readonly
                    >
                    <option value=""></option>
                    <option>21</option>
                    <option>22</option>
                    <option>23</option>
                    <option>24</option>
                    <option>25</option>
                    <option>26</option>
                    <option>27</option>
                    <option>28</option>
                    <option>29</option>
                    <option>30</option>
                  </select>
                  <label class="form-label" for="expiry-year"
                    >Expiry year (yy) <span class="asterisk">*</span></label
                    >
                  </span>
                </div>
              </div>
              <div class="row">
                <!-- Card Holder Name  -->
                <div class="col-md-8 no-padding">
                  <span class="has-float-label">
                    <input
                      type="text"
                      id="cardholder-name"
                      class="form-control input-field"
                      title="cardholder name"
                      aria-label="enter name on card"
                      value=""
                      tabindex="5"
                      readonly
                      placeholder=" "
                      />
                      <label class="form-label" for="cardholder-name"
                        >Cardholder's name <span class="asterisk">*</span></label
                        >
                      </span>
                    </div>
                    <!-- SECURITY CODE CVV  -->
                    <div class="col-md-4 no-padding">
                      <span class="has-float-label">
                        <input
                          type="password"
                          id="security-code"
                          class="form-control input-field"
                          title="security code"
                          aria-label="three digit CCV security code"
                          value=""
                          tabindex="4"
                          readonly
                          placeholder=""
                          />
                          <label class="form-label" for="security-code"
                            >Security code(CVV) <span class="asterisk">*</span></label
                            >
                          </span>
                        </div>
                      </div>
                    </form>
                    <!-- Pay Button -->
                    <div>
                      <button
                        id="payButton"
                        class="btn btn-lg btn-block checkout_form-button"
                        (click)="pay('card')"
                        >
                        Pay {{ cardpaymentreq.currency }} {{ cardpaymentreq.amount }}
                      </button>
                    </div>
                  </div>
                }
                <div id="3DSUI"></div>

                <!-- Loader -->
                @if (isLoading) {
                  <div class="text-center">
                    <div
                      class="spinner-border spinner-border"
                      style="width: 5rem; height: 5rem"
                      role="status"
                      >
                      <span class="sr-only">Loading...</span>
                    </div>
                    <br /><br />
                    <p style="color: black">Loading..</p>
                  </div>
                }
